import React, { Component } from "react";
import { Input, DatePicker } from "antd";
import { Dropdown } from "../../../../components/common/dropdown";
import moment from "moment";
import { apiDriver } from "../../../../api/api-driver";
import { apiConstract } from "../../../../api/api-constract";

export class SearchBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      birthdate: "",
      idCard: "",
      mobile: "",
      name: "",
      status: "",
      user_group: "",
      checkSearch: false,
      DRIVER_STATUS: [],
      USER_GROUP: [],
      branchList: [],
      branch_id: null,
    };
    //this.branchs = [];
  }

  async componentDidMount() {
    try {
      const [result, dataBranch] = await Promise.all([
        apiDriver.getFilterDriverOptions(),
        apiConstract.getBranch(),
      ]);

      if (dataBranch.status == "success") {
        let dataConvert = dataBranch.data.map((item) => {
          return {
            ...item,
            name: item.code,
          };
        });
        dataConvert.unshift({ id: -1, code: "all", name: "Tất cả" });
        this.setState({ branchList: dataConvert });
      }

      if (result.status === "success") {
        const { status, supplier_groups } = result.data;
        status.unshift({ id: -1, code: "all", name: "Tất cả" });
        supplier_groups.unshift({ id: -1, code: "all", name: "Tất cả" });
        this.setState({
          DRIVER_STATUS: status.map((item) => {
            return {
              ...item,
              code: item.value,
            };
          }),
          USER_GROUP: result.data.supplier_groups,
        });
      }
    } catch (error) {}
  }

  onChangeText = (feild, value) => {
    this.setState({ [feild]: value, checkSearch: false });
  };

  search = (event) => {
    if (event.keyCode === 13) {
      this.submitSearch();
      event.preventDefault();
    }
  };

  submitSearch = async () => {
    await this.setState({
      checkSearch: true,
    });
    this.props.search(1);
  };

  setStatus = (value) => {
    if (value.id == -1) {
      this.setState({ status: null, checkSearch: false });
    } else {
      this.setState({ status: value.code, checkSearch: false });
    }
  };

  setUserGroup = (value) => {
    if (value.id == -1) {
      this.setState({ user_group: null, checkSearch: false });
    } else {
      this.setState({ user_group: value.id, checkSearch: false });
    }
  };

  handleBirthdate = (date, dateString) => {
    const unixNew = moment(dateString, "DD/MM/YYYY").unix();
    this.setState({
      birthdate: unixNew * 1000,
      checkSearch: false,
    });
  };

  setBranch = (value) => {
    if (value.id == -1) {
      this.setState({
        branch_id: null,
        checkSearch: false,
      });
    } else {
      this.setState({
        branch_id: value.id,
        checkSearch: false,
      });
    }
  };

  render() {
    const { mobile, name, idCard, DRIVER_STATUS, USER_GROUP, branchList } =
      this.state;

    let driverStatus = DRIVER_STATUS;
    let userGroup = USER_GROUP;
    return (
      <div className="search-bar">
        <div className="search-journey-container">
          <div className="search-contract">
            <Input
              onKeyDown={this.search}
              onChange={(param) =>
                this.onChangeText("name", param.target.value)
              }
              value={name}
              placeholder="Tài xế"
              className="input"
            />
            <Input
              onKeyDown={this.search}
              onChange={(param) =>
                this.onChangeText("idCard", param.target.value)
              }
              value={idCard}
              placeholder="Mã số cá nhân"
              className="input"
            />
            <DatePicker
              // inputReadOnly
              dropdownClassName="date-picker-dropdown-bottom"
              getPopupContainer={(node) => {
                if (node) {
                  return node.parentNode;
                }
                return document.body;
              }}
              className="input"
              onChange={this.handleBirthdate}
              placeholder="Ngày sinh"
              format="DD/MM/YYYY"
              disabledDate={(currentDate) => {
                const currentTimes = currentDate.valueOf();
                const nowTimes = moment().endOf("day").valueOf();
                return currentTimes >= nowTimes;
              }}
            />
            <Input
              onKeyDown={this.search}
              onChange={(param) =>
                this.onChangeText("mobile", param.target.value)
              }
              value={mobile}
              placeholder="Số điện thoại"
              className="input"
            />
          </div>

          <div className="search-contract">
            <Dropdown
              select={(value) => this.setUserGroup(value)}
              className="input"
              menu={userGroup}
              title="Nguồn nhân sự"
            />
            <Dropdown
              select={(value) => this.setStatus(value)}
              className="input"
              menu={driverStatus}
              title="Trạng thái"
            />
            <Dropdown
              select={(value) => this.setBranch(value)}
              className="input"
              menu={branchList}
              title="Khu vực quản lý"
            />
            <div style={{ width: "24%" }}></div>
            <div style={{ width: "24%" }}></div>
          </div>
        </div>
        <div onClick={this.submitSearch} className="btn-success">
          <img
            alt=""
            onClick={this.submitSearch}
            style={{ objectFit: "contain", cursor: "pointer", marginRight: 5 }}
            width={16}
            src={require("../../../../assets/icons/search-solid-white.png")}
          />
          Search
        </div>
      </div>
    );
  }
}
